import smartlookClient from "smartlook-client";

const SmartlookPort = {
  add: function (app, projectKey) {
    smartlookClient.init(projectKey);

    app.ports.smartlookPortInit.subscribe(function (practice) {
      smartlook("identify", "anonymize", {
        practice_id: practice.id,
        practice_name: practice.name,
        practice_email: practice.email,
      });
    });

    app.ports.smartlookPortIdentify.subscribe(function (onlineEnrollmentId) {
      smartlook("identify", onlineEnrollmentId, {
        online_enrollment_id: onlineEnrollmentId,
      });
    });
  },
};

module.exports = SmartlookPort;
